import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { LocaleContext, useLocaleProvider } from '../hooks/useLocale'
import '../stylesheets/index.css'

const pages = import.meta.glob('../pages/**/*.tsx')

function LocaleProvider({ children }: { children: React.ReactNode }) {
  const value = useLocaleProvider()
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>
}

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page()
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <LocaleProvider>
        <App {...props} />
      </LocaleProvider>
    )
  },
})
